var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transactions-table',{attrs:{"url":"/api/v1/cryptoTransactions","show-user-details":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }